"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _crowdaaApi = _interopRequireDefault(require("crowdaa-api"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _reactRefetch = require("react-refetch");

var _reactIntl = require("react-intl");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  _setPrototypeOf(subClass.prototype, superClass && superClass.prototype);

  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.getPrototypeOf || function _getPrototypeOf(o) {
    return o.__proto__;
  };

  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var DistributionBadge =
/*#__PURE__*/
function (_React$PureComponent) {
  function DistributionBadge(props) {
    var _this;

    _classCallCheck(this, DistributionBadge);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DistributionBadge).call(this, props));
    _this.handlePress = _this.handlePress.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(DistributionBadge, [{
    key: "handlePress",
    value: function handlePress() {
      var _this$props = this.props,
          contentId = _this$props.contentId,
          onPress = _this$props.onPress;
      if (onPress) onPress(contentId);
    }
  }, {
    key: "render",
    value: function render() {
      var formatMessage = this.context.intl.formatMessage;
      var distribution = this.props.distribution;
      var className = 'border-0 badge badge-pill badge-';
      if (distribution.fulfilled) className += 'success';else if (distribution.pending) className += 'primary';else if (distribution.error) className += 'danger';
      return _react.default.createElement("button", {
        className: className,
        onClick: this.handlePress,
        onKeyUp: this.handlePress
      }, distribution.fulfilled && formatMessage({
        id: distribution.value
      }), distribution.pending && formatMessage({
        id: 'loading'
      }), distribution.error && formatMessage({
        id: 'error'
      }));
    }
  }]);

  _inherits(DistributionBadge, _React$PureComponent);

  return DistributionBadge;
}(_react.default.PureComponent);

_defineProperty(_defineProperty(_defineProperty(DistributionBadge, "propTypes", {
  contentId: _propTypes.default.string.isRequired,
  distribution: _propTypes.default.object,
  onPress: _propTypes.default.func
}), "contextTypes", {
  apiURL: _propTypes.default.string,
  intl: _reactIntl.intlShape,
  loginToken: _propTypes.default.string
}), "defaultProps", {
  distribution: {
    fulfilled: true,
    pending: false,
    error: false,
    value: 'locked'
  },
  onPress: null
});

var _default = _reactRefetch.connect.defaults((0, _crowdaaApi.default)({
  type: 'no-store'
}))(function (_ref, context) {
  var contentId = _ref.contentId,
      type = _ref.type,
      polling = _ref.polling;
  var apiURL = context.apiURL; // To make sure if polling prop is not set, always poll
  // for mobile app retro compatibility

  var pollingState = polling === true || polling === false ? polling : true;
  return {
    distribution: {
      context: context,
      force: true,
      refreshInterval: pollingState ? 10000 : 0,
      then: function then(_ref2) {
        var state = _ref2.state;
        return {
          value: state
        };
      },
      url: "".concat(apiURL, "/media/").concat(type || 'audio', "/").concat(contentId, "/lock")
    }
  };
})(DistributionBadge);

exports.default = _default;